import React from 'react';
import { Layout, Typography, Row, Col, Card, Avatar, Button,Space } from 'antd';
import { 
  TeamOutlined,
  SafetyOutlined,
  TrophyOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  UserOutlined
} from '@ant-design/icons';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './AboutPage.css';

import MianJaved from '../assets/images/Mian Javed.png';
// import Hashmi from '../assets/images/Hashmi.png';
import Lodhi from '../assets/images/Lodhi.png';
import Imran from '../assets/images/Imran.png';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const teamMembers = [
  {
    name: "Mian Muhammad Javed ",
    position: "Founder & Lead Consultant",
    bio: "Experience in healthcare accreditation",
    avatar: MianJaved,
    expertise: ["PHC Standards", "Quality Improvement", "Clinical Audits"]
  },
  {
    name: "Naeem Ahmed Khan Lodhi",
    position: "X Sectory bar,Lahore",
    bio: "Regulatory expert with deep knowledge of PHC requirements",
    avatar: Lodhi,
    expertise: ["Compliance Audits", "Risk Management", "Policy Development"]
  },
  {
    name: "Mian Imran",
    position: "Lawyer & Regulatory Advisor",
    bio: "Regulatory expert with deep knowledge of PHC requirements",
    avatar: Imran,
    expertise: ["Compliance Audits", "Risk Management", "Policy Development"]
  },
];

const milestones = [
  { year: "2020", event: "Company Founded", icon: <CalendarOutlined /> },
  { year: "2022", event: "First Regular liscence", icon: <TrophyOutlined /> },
  { year: "2023", event: "Expanded to Punjab", icon: <EnvironmentOutlined /> },
  { year: "2024", event: "50+ Registration Certificates", icon: <SafetyOutlined /> },
  { year: "2025", event: "100+ Successful Projects", icon: <TeamOutlined /> }
];

const AboutPage = () => {
  return (
    <Layout className="layout">
      <Header />
      <Content className="about-content">
  
        

        {/* Our Story Section */}
        <div className="our-story-section">
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Title level={2} className="section-title">Our Story</Title>
                <Paragraph className="section-text">
                  Founded with a vision to simplify healthcare compliance, Prime Health Care Consultancy was established to support medical facilities across Punjab in navigating the often-complex requirements of the <strong>Punjab Health Commission (PHC)</strong> .
                </Paragraph>
                <Paragraph className="section-text">
                  What started as a small advisory effort has now grown into a trusted name in healthcare consultancy built on integrity, knowledge, and a deep commitment to service. We’ve helped dozens of clinics, hospitals, and diagnostic centers achieve and maintain PHC compliance through expert guidance, tailored support, and hands-on documentation assistance.
                </Paragraph>
                <Paragraph className="section-text">
                  We believe that every healthcare provider deserves smooth access to regulatory guidance without confusion or delays. That’s why we handle every case with personal attention, professionalism, and a results-driven mindset.
                </Paragraph>
                <Paragraph className="section-text">
                  At Prime Health Care Consultancy, <strong>your compliance is our mission — and your success is our story.</strong> 
                </Paragraph>
              </motion.div>
            </Col>
            <Col xs={24} md={12}>
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <Card bordered={false} className="story-image-card">
                  <div className="hero-image">
              <iframe src="https://player.vimeo.com/video/1119170428?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{position:'absolute',top:'0',left:'0',width:'100%',height:'100%'}} title="Prime Health Care Consultancy | PHC Registration, Licensing &amp; Compliance Services in Punjab"></iframe>
              
            </div>
                </Card>
              </motion.div>
            </Col>
          </Row>
        </div>

        {/* Mission & Values */}
        <div className="mission-section">
          <Title level={2} className="section-title" style={{ textAlign: 'center' }}>Our Mission & Values</Title>
          <Row gutter={[24, 24]} style={{ marginTop: 48 }}>
            <Col xs={24} md={8}>
              <motion.div
                whileHover={{ y: -5 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <Card className="value-card">
                  <div className="value-icon" style={{ backgroundColor: '#e6f7ff' }}>
                    <SafetyOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                  </div>
                  <Title level={4} className="value-title">Quality First</Title>
                  <Paragraph className="value-text">
                    We believe accreditation should improve care quality, not just check boxes.
                  </Paragraph>
                </Card>
              </motion.div>
            </Col>
            <Col xs={24} md={8}>
              <motion.div
                whileHover={{ y: -5 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                <Card className="value-card">
                  <div className="value-icon" style={{ backgroundColor: '#fff7e6' }}>
                    <TeamOutlined style={{ fontSize: '32px', color: '#fa8c16' }} />
                  </div>
                  <Title level={4} className="value-title">Client Focused</Title>
                  <Paragraph className="value-text">
                    Custom solutions tailored to each facility's unique needs and challenges.
                  </Paragraph>
                </Card>
              </motion.div>
            </Col>
            <Col xs={24} md={8}>
              <motion.div
                whileHover={{ y: -5 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <Card className="value-card">
                  <div className="value-icon" style={{ backgroundColor: '#f6ffed' }}>
                    <TrophyOutlined style={{ fontSize: '32px', color: '#52c41a' }} />
                  </div>
                  <Title level={4} className="value-title">Proven Results</Title>
                  <Paragraph className="value-text">
                    95% success rate in helping facilities achieve their desired accreditation level.
                  </Paragraph>
                </Card>
              </motion.div>
            </Col>
          </Row>
        </div>

        {/* Our Team */}
        <div className="team-section">
          <Title level={2} className="section-title" style={{ textAlign: 'center' }}>Meet Our Team</Title>
          <Paragraph className="section-description" style={{ textAlign: 'center' }}>
            Experienced professionals with deep knowledge of PHC standards
          </Paragraph>
          
          <Row gutter={[24, 24]} style={{ marginTop: 48 }}>
            {teamMembers.map((member, index) => (
              <Col xs={24} md={8} key={index}>
                <motion.div
                  whileHover={{ y: -5 }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <Card className="team-card" hoverable>
                    <Avatar size={120} src={member.avatar} icon={<UserOutlined />} className="team-avatar" />
                    <Title level={3} className="team-name">{member.name}</Title>
                    <Text strong className="team-position">{member.position}</Text>
                    <Paragraph className="team-bio">{member.bio}</Paragraph>
                    <div className="team-expertise">
                      <Text strong>Expertise:</Text>
                      <ul>
                        {member.expertise.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>

        {/* Milestones */}
        <div className="milestones-section">
          <Title level={2} className="section-title" style={{ textAlign: 'center' }}>Our Journey</Title>
          <div className="milestones-timeline">
            {milestones.map((milestone, index) => (
              <motion.div 
                key={index}
                className="milestone-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="milestone-icon">
                  {React.cloneElement(milestone.icon, { style: { fontSize: '24px' } })}
                </div>
                <div className="milestone-year">{milestone.year}</div>
                <div className="milestone-event">{milestone.event}</div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="about-cta">
          <Title level={3}>Ready to Work With Us?</Title>
          <Paragraph>
            Contact our team of PHC experts today to discuss your healthcare establisment's needs.
          </Paragraph>
          <Space size="large" style={{ marginTop: 24 }}>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <a href="/contact"><Button type="primary" size="large" icon={<PhoneOutlined />}>
                Call Us Now
              </Button></a>
            </motion.div>
            <a href="/contact"><Button size="large" type="default">
              Send a Message
            </Button></a>
          </Space>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default AboutPage;